<template>
    <div class="input-item">
        <label v-if="label" class="input-item__label">{{ label }}</label>

        <!--
        <div class="input-item__password-reqs">
            <p class="input-item__password-reqs__item" :class="{ 'input-item__password-reqs__item--valid': contains_chars }">{{ $t('inc_chars') }}</p>
            <p class="input-item__password-reqs__item" :class="{ 'input-item__password-reqs__item--valid': contains_number }">{{ $t('inc_number') }}</p>
            <p class="input-item__password-reqs__item" :class="{ 'input-item__password-reqs__item--valid': valid_password_length }">{{ $t('inc_password_length') }}</p>
        </div>
        -->
        <input
            v-model="inputValue"
            type="password"
            class="input-item__input input"
            :class="{ 'input-item--error': vMessage.length > 0 }"
            @input="$emit('update:modelValue', handleInputChange($event))"
        />

        <p style="font-size: 0.75em;margin-top:2px;">{{ $t('password_helper_text') }}</p>

        <span v-if="vMessage.length > 0" class="input-item__error">
            <span class="input-item__error__msg">{{ vMessage[0] }}</span>
        </span>

        <!--
        <span
            class="input-item__password-length"
            :class="{
                'input-item__password-length--valid': valid_password_length,
                'input-item__password-length--show': typed
            }"
        >
            {{ password_length }}
        </span>
        -->
        
        <div
            class="input-item__password-valid"
            :class="{ 'input-item__password-valid--show' : valid_password }"
        >
            <svg width="100%" height="100%" viewBox="0 0 140 100">
                <path
                    d="M10,50 l25,40 l95,-70"
                    class="tick"
                    :class="{ checked: valid_password }"
                />
            </svg>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs, watchEffect } from 'vue'
    import useVuelidate from '@vuelidate/core'

    export default defineComponent({
        props: {
            modelValue: {
                type: String,
                required: false
            },
            vMessage: {
                type: Array,
                default: []
            },
            label: {
                type: String,
                required: false,
            }
        },
        emits: ['update:modelValue'],
        setup(props) {
            let v$ = useVuelidate()

            const data = reactive({
                password: null as null | string,
                password_length: 0,
                typed: false,
                contains_chars: false,
                contains_number: false,
                valid_password_length: false,
                valid_password: false
            })

            const state = reactive({ inputValue: '' })

            const passwordChecker = (string: string) => {
                const length = string.length

                const rules = {
                    contains_chars: /[a-zA-Z]/.test(string),
                    contains_number: /\d/.test(string),
                    validLength: length > 5,
                    password_valid: false
                }

                if (rules.contains_chars && rules.contains_number && rules.validLength) {
                    rules.password_valid = true
                }

                return rules
            }

            const handleInputChange = (event: Event) => {
                const value = (event.target as HTMLInputElement).value
                const rules = passwordChecker(value)

                data.password_length       = value.length
                data.valid_password_length = data.password_length > 5
                data.typed                 = data.password_length > 0

                data.contains_chars  = rules.contains_chars
                data.contains_number = rules.contains_number

                // Check if the password is valid
                if (rules.contains_chars && rules.contains_number && rules.validLength) {
                    data.valid_password = true
                }

                return value
            }

            watchEffect(() => {
                if (props.modelValue) {
                    state.inputValue = props.modelValue
                }
            })

            return {
                v$,
                ...toRefs(data),
                ...toRefs(state),
                handleInputChange,
            }
        }
    })
</script>
